import { useEffect, useLayoutEffect, useState } from "react";

const useContainerWidth = ({
  containerRef,
  useFirstChildWidth = false,
  sync = false,
}) => {
  const [width, setWidth] = useState(0);

  // `sync: true` runs the measure before paint via useLayoutEffect, so
  // consumers can branch on the width in the first paint without flicker.
  const useEffectFn = sync ? useLayoutEffect : useEffect;

  useEffectFn(() => {
    const container = containerRef?.current;
    if (!container) return;

    const measure = () => {
      const target =
        useFirstChildWidth && container.firstElementChild
          ? container.firstElementChild
          : container;
      setWidth(target.getBoundingClientRect()?.width);
    };

    measure();

    const resizeObserver = new ResizeObserver(measure);
    resizeObserver.observe(container);

    return () => {
      resizeObserver.disconnect();
    };
  }, [containerRef, useFirstChildWidth]);

  return width;
};

export default useContainerWidth;
